export interface ICategories {
    id:number,
    name:string,
    storeId:number,
}

export interface IDashbordCategoryFilterReponse {
    averageInvoice: number,
    deliveryDays: number,
    netBookings: number,
    leadFee: number,
    npsScore: number
    reviewsCount: number,
    reviews: number,
    totalInvAmount: number,
}

export const TotalCategories = [
    "Bookings",
    "Lead time",
    "Avg. Invoice (incl. VAT)",
    "Total invoice (incl. VAT)",
    "Lead fee (incl. VAT)",
    "Total reviews",
    "Avg. Rating",
    "NPS"
]
export const parxisTotalCategories = [
    "Bookings",
    "Lead time",
    "Lead fee (incl. VAT)",
    "Total reviews",
    "Avg. Rating",
    "NPS"
]
export const keyMap = {
    "Bookings": "netBookings",
    "Lead time": "deliveryDays",
    "Avg. Invoice (incl. VAT)": "averageInvoice",
    "Total invoice (incl. VAT)": "totalInvAmount",
    "Lead fee (incl. VAT)": "leadFee",
    "Total reviews": "reviewsCount",
    "Avg. Rating": "reviews",
    "NPS": "npsScore"
  };

export interface IDashbordCategoryReponseObj {
    [key: string]: number; // Allow any string as a key
  }